import { useState } from 'react'

const SESSION_KEY = 'fd_form_session'

export interface SessionData {
  step: number
  postcode: string
  category?: string
  subSelections?: string[]
  followUpValues?: Record<string, string>
  phone: string
  email: string
  name?: string
  address: string
  addressLine2?: string
  additionalInfo?: string
  jobId?: string
  jobSecret?: string
  jobRef?: string
  plumberCount?: number
}

export function loadSession(): Partial<SessionData> | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    return raw ? (JSON.parse(raw) as Partial<SessionData>) : null
  } catch {
    return null
  }
}

export function saveSession(data: Partial<SessionData>) {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(data))
  } catch { /* ignore */ }
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY)
}

export function useFormSession() {
  const [session] = useState<Partial<SessionData> | null>(loadSession)
  return { session, saveSession, clearSession, loadSession }
}
